<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl relative">
        Role użytkowników
        <div class="mb-6 flex justify-between items-center">
          <inertia-link class="btn-shtax ml-auto absolute right-0 top-0 disabled:opacity-50" :href="route('roles.create')">
            <span>Nowa</span>
            <span class="hidden md:inline">rola</span>
          </inertia-link>
        </div>
    </h1>

    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <tr class="text-left font-bold">
          <th class="px-6 pt-6 pb-4">Nazwa</th>
          <th class="px-6 pt-6 pb-4">Przestrzeń</th>
          <th class="px-6 pt-6 pb-4" colspan="2">Uprawnienia</th>
        </tr>
        <tr v-for="role in roles" :key="role.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center focus:text-shtax-500" :href="route('roles.edit', role.id)">
              {{ role.name }}
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center focus:text-shtax-500" :href="route('roles.edit', role.id)" tabindex="-1">
              {{ role.guard_name }}
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center flex flex-wrap" :href="route('roles.edit', role.id)" tabindex="-1">
              <div v-for="(permission, index) in role.permissions" class="mb-2 mt-2"> 
                <span class="px-3 py-1 bg-green-500 rounded-lg text-white text-sm">{{ permission.name }}</span>&nbsp; 
              </div>
            </inertia-link>
          </td>
          <td class="border-t w-px">
            <inertia-link class="px-4 flex items-center" :href="route('roles.edit', role.id)" tabindex="-1">
              <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400" />
            </inertia-link>
          </td>
        </tr>
        <tr v-if="roles.length === 0">
          <td class="border-t px-6 py-4" colspan="4">Brak określonych roli.</td>
        </tr>
      </table>
    </div>

  </div>
</template>

<script>
import Icon from '@/Shared/Icon'
import Layout from '@/Shared/Layout'

export default {
  metaInfo: { title: 'Role użytkowników' },
  components: {
    Icon
  },
  layout: Layout,
  props: {
    roles: Array
  },
  data() {
    return {
    }
  }
}
</script>
